import { IDashboard } from "@/models/IDashboard";
import { Vue, Component, Watch } from "vue-property-decorator";
import { RouteNames } from "@/router";
import { IActivation } from "@/models";
import { Roles } from "../../enums";

@Component({
    name: "Dashboard",
})
export default class Dashboard extends Vue {
    public routeNames = RouteNames;

    public search = "";

    public markets = [];

    public tab = "tab-1";

    public loading = false;

    public defaultFilter = "creationDate";

    public mostRecent = true;


    public headers = [
        {
            text: "Campaigns",
            align: "start",
            sortable: true,
            value: "activationName",
        },
        { text: "Activation Use Case", value: "labelActivationCase" },
        { text: "Activation Type", value: "labelActivationType" },
        { text: "Brands", value: "brands" },
        { text: "Markets", value: "markets" },
        { text: "Start - end dates", value: "startDate" },
        { text: "Brief creation date", value: "creationDate" },
        { text: "Creator", value: "email" },
        { text: "Status", value: "status" },
    ];

    get userId(): string {
        return this.$store.getters["account/userId"];
    }

    get isNotMember(): boolean {
        return this.$store.getters["account/user"]?.roleId !== Roles.Member;
    }

    get activationByUser(): IActivation[] {
        const items = this.$store.getters["app/dashboard"] ?? [];
        return items;
    }

    @Watch("tab")
    currentActivation(): void {
        if (this.tab === "tab-2"){
            this.loading = true;
            this.$store.dispatch(
                "app/loadPastActivation",
                this.userId,
            ).then(response => {
                this.loading = false;
            }, error => {
                console.error("this is error");
            });
        }

        else{
            this.loading = true;
            this.$store.dispatch(
                "app/loadActivationByUser",
                this.userId,
            ).then(response => {
                this.loading = false;
            }, error => {
                console.error("this is error");
            });
        }
    }

    async mounted(): Promise<void> {
        try {

            this.loading = true;
            await this.$store.dispatch(
                "app/loadActivationByUser",
                this.userId,
            );
        } catch (error) {
            this.$emit("error", error);
        }
        this.loading = false;
    }
}
